import React, {useEffect, useState} from 'react';
import {Form, Input, Button} from 'reactstrap';
import CommPFindAgncy from './CpmCommPFindAgncy';
import CommSelect from './CpmCommSelect';
import {formatSelect} from '../../script/commFunc';
import { useExtSubmission } from 'api';

/**
 *
 * User : 이연우
 * Date : 2023.05.04
 * @ file : Components/Common/CpmCommAgncyOffc.js
 * @ Desc : 광고회사 공통 Component
 * @param {object} params - 부모 컴포넌트로부터 받아온 파라미터 객체
 * @param {React.SetStateAction} setParams - 부모 컴포넌트로부터 받아온 파라미터 세터
 * @param {Function} handleFocusCliRef - 광고주 컴포넌트로 포커스 변경 함수
 * @param {boolean} isDisabled - disabled 여부
 * @param {boolean} essential - 필수 여부
 */
const CpmCommAgncyOffc = ({
    params, 
    setParams, 
    handleFocusCliRef, 
    isDisabled, 
    essential = false,
    cable = ""
}) => {
    const extSubmission = useExtSubmission();
    const disabled = (sessionStorage.getItem("agncyNm") || sessionStorage.getItem("cliNm")) ? true : isDisabled; // disabled 체크
    const [options, setOptions] = useState([]); // 자동완성 광고회사 리스트
    const [modalIsOpen, setModalIsOpen] = useState(false); // 모달 열림 여부

    // 부모의 파라미터에 props 세팅
    const setParam = (props) => {
        setParams({...params, ...props});
    }

    // 부모의 파라미터 광고회사 이름, 아이디 초기화
    const initParams = () => {
        setParam({agncyNm: '', agncyId: ''});
    }

    // 광고회사 리스트 조회 API  
    const getAgncyOffcList = async (param, type) => {
      if(cable === "Y") param.cable = "Y";
      await extSubmission(
            "/cpm/com/commAgncyOffc/subList.do",
            param,
            (e, data) => {
                setOptions(formatSelect(data.listMain, 'agncyNm', 'agncyId'))
                if (type === 'Enter'){ // 엔터 시 
                    if (data.listMain.length === 1) { // 리스트에 값이 1개면 그 값 광고회사에 입력
                        onChangeSelect(formatSelect(data.listMain, 'agncyNm', 'agncyId')[0]);
                    } else { // 아니면 모달 열기
                        handleModal();
                    }
                }
            },
            'N'
        );
    }

    // 광고회사 Select 박스에서 선택시 광고회사 데이터 세팅
    const onChangeSelect = (select) => {
        setParam({agncyNm: select.label, agncyId: select.value});
        handleFocusCliRef(); // 광고주 input으로 포커스 이동
    }

    // 광고회사 Select 박스에 text가 입력 됐을 때 작동되는 함수
    const onChangeSelectInput = (value) => {
        if (value.length === 1) { // 값이 하나라도 입력되면 광고회사 데이터 초기화
            initParams(); 
        } else if (value.length >= 2) { // 2글자 이상이면 광고회사 리스트 조회 (자동완성)
            getAgncyOffcList({agncyId: value});
        } else { 
            setOptions([]);
        }
    }

    // 모달 열림 제어 함수
    const handleModal = () => {
        setModalIsOpen(!modalIsOpen);
    }

    // 광고회사 아이디 세팅 함수
    const onChangeAgncyId = (e) => {
        setParam({agncyNm: '', agncyId: e.target.value});
    }

    // 광고회사 이름, 아이디 세팅 함수
    const onChangeParams = (value) => {
        setParam({agncyNm: value.agncyNm, agncyId: value.agncyId});
        handleFocusCliRef(); 
    }

    // 광고회사 아이디 input에서 키보드를 눌렀을 때 작동 함수
    const onKeyPressAgncyId = async (e) => {
        if (e.key === 'Enter') {
            await getAgncyOffcList({agncyId: params.agncyId}, 'Enter'); // 광고회사 리스트 조회 (자동완성)
        }
    }

    useEffect(() => {
        // 스토리지에 광고주 이름, 아이디가 있는지 확인 
        if(sessionStorage.getItem("agncyNm") && !params.agncyNm){
            const agncyNm = sessionStorage.getItem("agncyNm")
            const agncyId = sessionStorage.getItem("agncyId")
            setParams({agncyId, agncyNm})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const selectProps = {
        options,
        select: {value: params?.agncyId, label: params?.agncyNm},
        onChangeSelect,
        onChangeInput: onChangeSelectInput,
        isDisabled: disabled,
        name: '광고회사',
        essential,
    }

    const modalProps = {
        agncyStr: params?.agncyId,
        modalIsOpen,
        handleModal,
        onChangeParams ,
        cable: cable || "",
    }

    return (
        <>
            <Form 
                className='d-flex align-items-center'
                autoComplete="off"
                style={{width: '280px',minWidth: '250px', maxWidth:'300px' }}
            >
                <Input
                    className={`${essential && 'essential'} form-control-sm me-1`}
                    style={{
                        width: '80px',
                        textAlign: 'center'
                    }}
                    name="광고회사"
                    id="agncyId"
                    value={params?.agncyId || ''}
                    onKeyPress={onKeyPressAgncyId}
                    onChange={onChangeAgncyId}
                    onFocus={(e) => e.target.select()}
                    disabled={disabled}
                    maxLength={8}
                    />
                <CommSelect {...selectProps} />
                {!disabled && <Button size='sm'
                        color=''
                        className='btn-icon btn-sm  btn-soft-dark px-2 fs-6 rounded-1 bx bx-search'
                        style={{borderColor:"#a9a8a8",height:"28px", width:"28px"  }}
                        disabled={disabled}
                        onClick={() => disabled ? null : [initParams(), handleModal()]}>
                </Button>}
            </Form>
            <CommPFindAgncy {...modalProps}/>
        </>
    )
};

export default CpmCommAgncyOffc;